module.exports = __webpack_public_path__ + "static/media/sophisticated-2.8e891809.png";